import { useReactFlow, Handle, Position, NodeResizer } from "@xyflow/react";
import { Button, Input } from "antd";
import { CloseOutlined, CopyOutlined } from "@ant-design/icons";
import NodeNameInput from "./NodeNameInput";

const COLOR = "#10b981";

const LocationNode = ({ data, selected, id }) => {
  const { deleteElements } = useReactFlow();

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? COLOR : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
    }}>
      <NodeResizer minWidth={240} minHeight={80} isVisible={selected} color={COLOR} />
      <Handle type="target" position={Position.Left} style={{ background: COLOR }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <span style={{ fontSize: 16 }}>📍</span>
        <strong style={{ fontSize: 13 }}>Request Location</strong>
        <Button type="text" size="small" icon={<CopyOutlined />}
          onClick={() => data.onDuplicate?.()}
          style={{ marginLeft: "auto", color: "#9ca3af" }} />
        <Button type="text" size="small" icon={<CloseOutlined />}
          onClick={() => deleteElements({ nodes: [{ id }] })}
          style={{ color: "#9ca3af" }} />
      </div>

      <div className="nodrag" onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
        <NodeNameInput data={data} />
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 3 }}>Request message</div>
          <Input.TextArea
            value={data.body || ""}
            onChange={(e) => data.onChange?.({ ...data, body: e.target.value })}
            rows={2}
            size="small"
            placeholder="Please share your location so we can assist you."
          />
        </div>

        <div style={{ fontSize: 10, color: COLOR, padding: "3px 6px", background: `${COLOR}11`, borderRadius: 4 }}>
          📌 Coordinates saved to contact notes field on reply
        </div>
      </div>

      <Handle type="source" position={Position.Right} style={{ background: COLOR }} />
    </div>
  );
};

export default LocationNode;
